import React, { useRef } from "react";
import ScrollArrowButtons from "../../common/ScrollArrowButtons";
import LabelHeading from "../../common/LabelHeading";
import LifeCard from "./LifeCard";
import { assets } from "../../../Assets/assets";

const LifeAtNatio = () => {

  const lifeData = [
    { img: assets.lifecardimg1, text: "Fun Friday funny moments at Natio Management Services Pvt. Ltd." },
    { img: assets.lifecardimg2, text: "Fun Friday funny moments at Natio" },
    { img: assets.lifecardimg3, text: "Employee's Birthday Celebration" },
    // { img: assets.lifecardimg1, text: "Fun Friday funny moments at Natio Management Services Pvt. Ltd." },
    // { img: assets.lifecardimg2, text: "Fun Friday funny moments at Natio" },
    // { img: assets.lifecardimg3, text: "Employee's Birthday Celebration" },
  ];

  const scrollRef = useRef(null);

  const scrollLeft = () => {
    scrollRef.current.scrollBy({ left: -320, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current.scrollBy({ left: 320, behavior: "smooth" });
  };

  return (
    <section className="w-full bg-[#ECF7FC] relative">

      <img src={assets.life} alt="" className="absolute w-full h-full object-cover object-top opacity-20" />

      <div className="max-w-[1400px] mx-auto px-6 pt-16 pb-5 relative z-10">

        <LabelHeading
          label="Life At Natio"
          heading="Life at Natio"
          text="We grow together, support each other, and celebrate every milestone as a family."
        />

        <div className="mt-6 space-y-4">
          <div data-aos="fade-up-left" data-aos-duration="1000" className="flex justify-end gap-3">
            <ScrollArrowButtons scrollLeft={scrollLeft} scrollRight={scrollRight} />
          </div>

          <section
            ref={scrollRef}
            className="no-scrollbar flex gap-6 xl:gap-8 overflow-x-auto overflow-y-hidden snap-x snap-mandatory pb-4"
          >
            {lifeData.map((item, index) => (
              <LifeCard index={index} key={index} img={item.img} text={item.text} />
            ))}
          </section>
        </div>
      </div>
    </section>
  );
};

export default LifeAtNatio;
